var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.792 32.5q-1.084 0-1.854-.771-.771-.771-.771-1.854v-19.75q0-1.083.771-1.854.77-.771 1.854-.771h26.416q1.084 0 1.854.771.771.771.771 1.854v19.75q0 1.083-.771 1.854-.77.771-1.854.771ZM20 20.458 6.25 11.5v18.375q0 .25.146.396.146.146.396.146h26.416q.25 0 .396-.146.146-.146.146-.396V11.5Zm0-2.166 13.417-8.709H6.625ZM6.25 11.5V9.583v20.292q0 .25.146.396.146.146.396.146H6.25v-.542Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.3973913ddcaa748f49af928fb7508e18.svg";
export { ForwardRef as ReactComponent };